import { cn } from '@/lib/cn';
import FillScreen from '../Layout/FillScreen';
import { Loader } from './Loader';

/**
 * 描画対象のビューポートに対してローディング表示を行うコンポーネント。
 * 親要素のサイズに応じて表示領域が決定されます。
 *
 * @example
 * ```tsx
 * // Suspenseと組み合わせて使用
 * <Suspense fallback={<ViewportLoader />}>
 *   <SomeComponent />
 * </Suspense>
 * ```
 */
interface ViewportLoaderProps {
  className?: string;
}
export function ViewportLoader({
  className
}: ViewportLoaderProps) {
  return <FillScreen className={cn('grid place-items-center', className)}>
      <Loader />
    </FillScreen>;
}